import { LanguageProvider } from '@web_opxp/features';
import { Provider } from 'react-redux';
import { Route, Routes } from 'react-router';
import { IsDebug, LocalesBaseUrl } from '../base/env';
import AllVideosPage from './AllVideosPage';
import GalleryPage from './GalleryPage';
import { store } from './store';

const GalleryApp = () => {
  return (
    <Provider store={store}>
      <LanguageProvider
        fallbackNS="prereg"
        localesPath={LocalesBaseUrl}
        debug={IsDebug}
        supportedLngs={['de']}
        ns={['prereg']}
        defaultNS="prereg">
        <Routes>
          <Route path="" element={<GalleryPage />} />
          <Route path="all" element={<AllVideosPage />} />
        </Routes>
      </LanguageProvider>
    </Provider>
  );
};

export default GalleryApp;
